export const MAX_LENGTH_NAME = 25;
export const MIN_LENGTH_NAME = 3;
export const MAX_LENGTH_COLOR = 21;

/**
 * Creates an html URI from a path and a query object
 */
export function createURI(path, { params, query } = {}) {
    function serialize(obj) {
        var str = [];
        for (var p in obj)
            if (obj.hasOwnProperty(p) && obj[p] !== undefined) {
                str.push(p + "=" + obj[p]);
            }
        return str.join("&");
    }

    const pathWithParams = params ? injectVariables(path, params) : path;
    return query ? `${pathWithParams}?${serialize(query)}` : pathWithParams;
}

export function injectVariables(/** @type {string} */ url, /** @type {{[key: string]: any}}  */ vars) {
    return Object.keys(vars).reduce((acc, key) => {
        if (vars[key] === undefined) return acc;
        return acc.replace(`:${key}`, vars[key]);
    }, url);
}

export function createUUID() {
    let dt = new Date().getTime();
    let uuid = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, c => {
        let r = (dt + Math.random() * 16) % 16 | 0;
        dt = Math.floor(dt / 16);
        return (c == "x" ? r : (r & 0x3) | 0x8).toString(16);
    });
    return uuid;
}

String.prototype.interpolate = function interpolate(args) {
    return Object.keys(args).reduce((acc, key) => {
        return acc.replace(`{{${key}}}`, args[key]);
    }, this);
};

/**
 * Check if is a correct string
 * @param string
 * @returns {*|boolean}
 */
export function isString(string) {
    return string && typeof string === "string";
}

export function isNotEmpty(str) {
    console.assert(typeof str === "string" || !str);
    return str && str.trim().length > 0;
}

/**
 * Return a bool if the string given is a valid name
 * @param string {String}
 * @param length {Number}
 * @returns {boolean}
 */
export function isValidNameLength(string, length = MAX_LENGTH_NAME) {
    return string && string.trim() && string.trim().length <= length;
}

/**
 * Add space between word to have readable string
 * Ex : haveSome => Have Some :)
 * @param string
 * @returns {string}
 */
export function addSpacesBetweenWords(string) {
    if (typeof string !== "string") return "";
    return string.replace(/([A-Z])/g, " $1").trim();
}

/**
 * Capitalize a word
 * @param string
 * @returns {string}
 */
export function capitalize(string) {
    if (typeof string !== "string") return "";
    return string.charAt(0).toUpperCase() + string.slice(1);
}

export function removeNbsp(string) {
    if (!string) {
        return string;
    }
    return string.replace(/\s/g, " ");
}



// WEBPACK FOOTER //
// ./src/utils/string.js